export const environment = {
  baseUrl: 'https://chatbot-api.abg-mynd.com',
  // ACE assets are served from this app's own origin (src/assets/ace, shipped by
  // nginx). The library's default points at a private LAN host that does not exist
  // in deployed environments, and there is no ACE asset server there to proxy to.
  assetBaseUrl: '/assets/ace',
  appVar: "chatadmin",
  // Canonical SSO host. The ACE login component builds
  // `${ssoBaseUrl}/oidc/login?appVar=...` from this; without it the library falls back to
  // `${baseUrl}/sso`, which points the browser at this app's own gateway — which does not
  // host SSO. It must stay the SSO service's own origin so the JSESSIONID it issues and the
  // Azure callback (/sso/login/oauth2/code/azure) land on the same host.
  ssoBaseUrl: 'https://abg-reporting-api.abg-ace.ai/sso',
  version: "1.0.0",
  playlistsUrl: 'https://chatbot-api.abg-mynd.com/core/',
  // Internal development hosts. This branch talks to the LAN gateway, not the public
  // chatbot-api host the dr branch uses. The topics API is still called directly because
  // the LAN gateway does not serve the /topics/** route yet.
  topicsApiBaseUrl: 'http://172.105.79.110:8000',
  case_api_url: '/case-management',
  new_case_api_url: '/new-case-mgmt/casemanagement',
  workflow_api_url: '/workflow/',
  alert_api_url: '/alert',
  configuration_api_url: '/product-common/api',
  common_url: '/case-rule-common/api',
  rule_api_url: '/rule-management/api',
  notification_api_url: '/notification-service',
  report_api_url: '/report/api',
  outOfScopeUrl: 'https://chatbot-api.abg-mynd.com/chat/api/out-of-scope',
  knowledgeSourceLoadingUrl: '172.105.79.110:9201/ingest/web/batch',
  endpoints: {
    getAudit: 'ace-common/api/logs/all',
    avatarCore: {
      getAllVoices: 'chat/api/v1/voice-setting',
      updateNewVoice: 'chat/api/v1/voice-setting/{id}/select',
      getAvatars: 'core/avatar',
      getAvatarVoices: 'core/avatar-voice',
      getAvatarConfigurationByAvatarId: 'core/avatar-configuration/avatar/{id}',
      getAvatarThemes: 'core/avatar-themes',
      getAvatarThemeById: 'core/avatar-themes/{id}',
      updateKnowledgeBase: 'core/avatar-configuration/update-knowledge-base',
      setDefaultAvatar: 'core/avatar/set-default/{avatarId}',
      updateAvatarSettings: 'core/avatar-settings/update-settings',
      getAvatarSettings: 'core/avatar-settings/settings',
      updateAvatarSettingsShuffleMode:
        'core/avatar-settings/shuffle-mode?shuffleMode={bool}',
      updateAvatarIdleTime:
        'core/avatar-settings/idle-time?idleTime={idleTime}',
      playlistSettings: 'core/avatar-settings/playlist-settings',
      playlistSettingsMessage: 'avatar-settings/playlist-settings',
      updateBackgroundColor: 'core/avatar-settings/update-avatar-bg/{bgValue}',
      updateAvatarBackgroundColor: 'core/avatar/update-avatar-bg',
      addAvatarThemes: 'core/avatar-themes/add-avatar-theme',
      deleteAvatarTheme: 'core/avatar-themes/delete-avatar-theme',
      getLanguages: 'core/languages',
      getMetrics: 'chat/api/v1/dashboard',
      updateWelcome: 'chat/api/v1/system-setting/update-welcome',
      getSystemSetting: 'chat/api/v1/system-setting',
      getReports: 'chat/api/v1/report',
      getWebSearches: 'chat/api/v1/web-search',
      getUserExperience: 'chat/api/v1/user-experience',
      messageFeedback: '/chat/api/v1/message-feedbacks/system',
      channelManagement: '/chat/api/channel-management',
      // Error Management. Admin-only (ROLE_ADMIN) via the /api/v1/admin prefix rule in
      // chat-service's SecurityConfig — the responses carry stack traces.
      errorManagement: '/chat/api/v1/admin/errors',
      channels: '/chat/api/channel',
      addKnowledgeSource: 'chat/api/knowledgeSource/add',
      getKnowledgeSources: 'chat/api/knowledgeSource/',
    },
    usageManagement: {
      config: 'chat/api/v1/admin/usage/config',
      summary: 'chat/api/v1/admin/usage/summary',
      users: 'chat/api/v1/admin/usage/users',
      resetUser: 'chat/api/v1/admin/usage/users/{userId}/reset',
      resetAll: 'chat/api/v1/admin/usage/reset-all',
    },
    contextManagement: {
      get: 'chat/api/context-management',
      update: 'chat/api/context-management',
    },
    contextProfiles: {
      getAll: 'chat/api/profiles',
      getById: 'chat/api/profiles/{id}',
      create: 'chat/api/profiles',
      update: 'chat/api/profiles/{id}',
      activate: 'chat/api/profiles/{id}/activate',
      switchStatus: 'chat/api/profiles/switch-status',
      documents: 'chat/api/profiles/{id}/documents',
      documentById: 'chat/api/profiles/{id}/documents/{documentId}',
      documentFile: 'chat/api/knowledge-intake/{documentId}/file',
    },
    knowledgeIntake: {
      getAll: 'chat/api/knowledge-intake',
      getById: 'chat/api/knowledge-intake/{id}',
      create: 'chat/api/knowledge-intake',
      update: 'chat/api/knowledge-intake/{id}',
      delete: 'chat/api/knowledge-intake/{id}',
      toggleActive: 'chat/api/knowledge-intake/{id}/active',
    },
    noiseDictionary: {
      getAll: 'chat/api/noise-dictionary',
      getById: 'chat/api/noise-dictionary/{id}',
      create: 'chat/api/noise-dictionary',
      update: 'chat/api/noise-dictionary/{id}',
      delete: 'chat/api/noise-dictionary/{id}',
      toggleEnabled: 'chat/api/noise-dictionary/{id}/enabled',
      getCategories: 'chat/api/noise-dictionary/category/all',
      getLogs: 'chat/api/noise-dictionary/logs',
      getVariants: 'chat/api/noise-dictionary/{id}/variants',
      addVariant: 'chat/api/noise-dictionary/{id}/variants',
      deleteVariant: 'chat/api/noise-dictionary/variants/{variantId}',
    },
    languages: {
      getEnabled: 'ace-common/api/languages/enabled',
    },
    faq: {
      base: 'chat/api/faq',
    },
    defaultQuestions: {
      base: 'chat/api/default-questions',
    },
  },
  constants: {
    appSlogant: 'AI That Thinks With You',
  },
  datasets: {
    count: '/core/api/dataset/count',
  },
};
